import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { RecordPageComponent } from './../../record-page/record-page.component';
import { Component, OnInit } from '@angular/core';
import { Cell } from '../../cell';
import { LayoutService } from '../../layout.service';
import { ModuleInformation } from 'src/app/models/module-information';
import { InboxService } from '@app/services/InboxService.service';
import { NzNotificationService } from 'ng-zorro-antd/notification';

@Component({
  selector: 'app-cell-link',
  templateUrl: './cell-link.component.html',
  styleUrls: ['./cell-link.component.less'],
})
export class CellLinkComponent extends Cell {
  constructor(
    private inboxService: InboxService,
    private notification: NzNotificationService,
    public layoutService: LayoutService,
    public drawerService: NzDrawerService
  ) {
    super(layoutService, drawerService);

  }

  onApprovalSubmit() {
    this.inboxService
      .changeApprovalStatus(
        this.ApprovalMessage.WddCode,
        this.approvalForm.get('AppStatus').value,
        this.approvalForm.get('AppRemark').value
      )
      .subscribe((d: any) => {
        if (d.Has_Error) {
          this.notification.create('error', '', d.Error_Message);
        } else {
          this.notification.create(
            'success',
            'Status changed',
            'Approval Status changed successfuly'
          );
        }
      });
  }

  openDraftDocument(docEntry, immediately = false) {
    RecordPageComponent.openRecordPage(this.drawerService, {
      actionType: 'View',
      drawerTitle: 'View Details',
      inDrawer: true,
      moduleId: immediately ? 59 : this.ApprovalMessage.ModuleId,
      parentComponent: this,
      recordId: docEntry,
      recordModel: undefined,
      fromDraft: immediately ? false : (this.ApprovalMessage.ModuleId != 59 && this.ApprovalMessage.IsDraft == 'Y')
    });
  }
}
